import axios from "axios";
import { BASE_URL } from "../constants/constants";

export const loginApi = async (body) => {
    console.log(`${BASE_URL}/v0/auth/admin/sign-in`)
    return await axios
    .post(`${BASE_URL}/v0/auth/admin/sign-in`, body)
    .then((response) => response)
    .catch((error) => error);
};
